/**
 * Generates the private Auth identifier used only by ZSB.
 * The user still enters their real business e-mail; this separates the
 * password credential from any other application sharing the Supabase project.
 */
export async function zsbAuthEmail(loginEmail: string): Promise<string> {
  const normalized = loginEmail.trim().toLowerCase();
  const bytes = new TextEncoder().encode(`zsb-precificacao:${normalized}`);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  const hex = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
  return `zsb.${hex.slice(0, 40)}@login.invalid`;
}
